import * as React from 'react'
import { Navbar, NavbarGroup, Button, Popover, Menu, MenuItem, Position } from '@blueprintjs/core';


const UserMenu = ({user}) => {
  const userMenu = (
    <Menu>
      <MenuItem text="Sign out" href="/logout" />
    </Menu>
  );

  return (
    <Popover content={userMenu} position={Position.BOTTOM}>
      <Button icon="user">{user.name}</Button>
    </Popover>
  );
}

type TopBarProps = {
  current: any,
  user: any,
}

export default class TopBar extends React.Component<TopBarProps> {
  render() {
    const { current, user } = this.props;
    return (
      <div className="TopBar">
        <Navbar>
          <NavbarGroup align="left">
            <a href="/">
              <img className="_logo" src="/logo-white.svg" alt="How a Car Works" />
            </a>
            {user && user.products.length == 0 &&
              <a href="/video-course">Learn about the video course</a> }
          </NavbarGroup>

          <NavbarGroup align="right">
            { user ?  
              <UserMenu user={user} /> : 
              <a className="bp3-button" href="/login">Sign in</a>
            }
          </NavbarGroup>
        </Navbar>
      </div>
    );
  }
}
